import { logError } from '@core/logging'

import { useSocketContext } from './SocketContext'

/**
 * Reconnects the socket if the socket is closed
 */
export const useReconnectClosedSocket = () => {
  const { socket, recreateSocket } = useSocketContext()

  const reconnectClosedSocket = () => {
    // Expected behaviour as widget availability being hidden will not initiate socket
    if (!socket) {
      recreateSocket?.()
      return
    }

    if (socket.connectionState() === 'closed') {
      try {
        socket.reconnect()
      } catch (error) {
        logError(new Error('Failed to reconnect socket'))
        recreateSocket?.()
      }
    }
  }

  return reconnectClosedSocket
}
